import React from 'react'
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom"
import { TEMPLATES } from '../constants'
import * as Routes from '../constants/routes'
import { HSGraduation } from '../pages/hs-grad';
import { AppData } from '../data'
import { COLGradAnnouncements } from "../pages/col-grad-annc";
import { ColGradPackages } from '../pages/col-grad-pkg';

const App = () => {

  return (
    <Router>
      <Switch>
        <Route path={Routes.HOME}>
          {
            window.template === TEMPLATES.HS_GRAD && Object.keys(AppData.packageBrowseData)?.length > 0 && <HSGraduation appData={AppData} />
          }
          {
            window.template === TEMPLATES.COL_GRAD_ANNC && Object.keys(AppData.packageBrowseData)?.length > 0 && <COLGradAnnouncements appData={AppData} />
          }
          {
            window.template === TEMPLATES.COL_GREG_PKG && Object.keys(AppData.packageBrowseData)?.length > 0 && <ColGradPackages appData={AppData} />
          }
        </Route>
      </Switch>
    </Router>
  )
}

export default App
